import { useNavigate } from "react-router-dom";

import man from "../../../assets/images/dashboard/1.png";
import { Col, Row } from "react-bootstrap";
import { Issues, Resolved, Comment, Done } from "../../../Constant";
import { Progress } from "reactstrap";
import icons from "../../../Data/icons";
const SingleTasks = ({ task }) => {
  const {
    id,
    status, 
    progress,
    name,
    publisher,
    lists_count,
    notes_count
  } = task;
  const percentage = Math.min(Math.max(progress, 0), 100);
  const navigate = useNavigate();
  const EyeIcon = icons.eye;
  const EditIcon = icons.pen;
  const DeleteIcon = icons.trash;



  return (
    <tr>
      <td>{name}</td>
      <td><span
          className={`badge ${
           status === "completed" ? "badge-success" :  status === "expired"? "badge-danger" :status === "pending" ? "badge-info" :status ==="started" ?"badge-primary" :"badge-warning"
          }`}>
          {status} 
        </span></td>
      <td>
      {progress === "100" ? (
        <div class="progress">
          <div class="progress-bar bg-warning" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{width: progress}}></div>
        </div>
          ) : (
            <div class="progress">
          <div class="progress-bar bg-primary" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{width: progress}}></div>
        </div>
          )}
      </td>
    </tr>
  );
};

export default SingleTasks
